<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center p-4"
>

  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="report-title"
    aria-describedby="report-description"
    class="relative bg-white rounded-xl shadow-xl max-w-full max-h-[95vh] flex flex-col overflow-hidden"
    [ngClass]="phase === 0
      ? 'w-[400px] xl:w-[490px] 2xl:w-[580px] 3xl:w-[640px] h-[300px] xl:h-[320px] 2xl:h-[340px] 3xl:h-[360px]'
      : 'w-[1040px] h-[88vh]'"
  >
    <!-- Header -->
    <div class="shrink-0 px-6 xl:px-7">
      <div
        class="flex items-center justify-between min-h-[55px] xl:min-h-[57px] 2xl:min-h-[60px] py-2.5 bg-white border-b border-gray-200"
      >
        <div>
          <h2
            id="report-title"
            class="text-[0.9rem] xl:text-[1rem] 2xl:text-[1.1rem] 3xl:text-[1.2rem] font-bold text-dimot-1"
          >
            Report Nazionale
          </h2>
          <p
            id="report-description"
            class="text-[0.68rem] xl:text-[0.68rem] 2xl:text-[0.81rem] 3xl:text-[0.93rem] text-gray-500 mt-1"
          >
            {{ phase === 0 ? 'Scegli una delle due opzioni' : 'Seleziona i widget da includere nel report' }}
          </p>
        </div>

        <button
          type="button"
          aria-label="Chiudi"
          (click)="closeModal()"
          class="cursor-pointer text-dimot-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dimot-1/20"
        >
          <svg
            aria-hidden="true"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          >
            <path d="M5 5l14 14M19 5L5 19" />
          </svg>
        </button>
      </div>
    </div>

    <!-- PHASE 0 -->
    <ng-container *ngIf="phase === 0">
    <!-- Body -->
    <div
      class="flex-1 min-h-0 overflow-y-auto px-6 xl:px-7 py-5 xl:py-6 2xl:py-7"
    >
      <div
        class="grid grid-cols-2 grid-rows-[minmax(0,1fr)] gap-3 xl:gap-4
               h-full"
      >
        <!-- Card: Completo -->
        <button
          type="button"
          (click)="selected = 'all'"
          [attr.aria-pressed]="selected === 'all'"
          class="group relative h-full min-h-0 min-w-0 flex flex-col overflow-y-auto text-left
                 rounded-lg border border-gray-200 bg-white
                 p-3.5 xl:p-4 2xl:p-5 cursor-pointer
                 transition-colors duration-200 motion-reduce:transition-none
                 hover:border-dimot-1/40 hover:bg-dimot-1/[0.015]
                 aria-pressed:border-dimot-1 aria-pressed:hover:border-dimot-1 aria-pressed:bg-dimot-1/[0.03]
                 focus:outline-none focus-visible:ring-2 focus-visible:ring-dimot-1/20 focus-visible:ring-offset-2"
        >
          <div class="flex shrink-0 items-start justify-between gap-3 w-full mb-4">
            <div
              class="shrink-0 w-8 h-8 xl:w-9 xl:h-9 2xl:w-10 2xl:h-10 rounded-md bg-dimot-1/[0.07] flex items-center justify-center"
            >
              <svg
                aria-hidden="true"
                class="w-4 h-4 xl:w-[1.1rem] xl:h-[1.1rem] 2xl:w-5 2xl:h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#141F58"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
                <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
                <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
                <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
              </svg>
            </div>

            <!-- Selection indicator -->
            <span
              aria-hidden="true"
              class="mt-0.5 w-4 h-4 shrink-0 rounded-full border border-gray-400 flex items-center justify-center
                     transition-colors duration-200
                     group-aria-pressed:border-dimot-1 group-aria-pressed:bg-dimot-1"
            >
              <span
                class="w-1.5 h-1.5 rounded-full bg-white opacity-0 group-aria-pressed:opacity-100"
              ></span>
            </span>
          </div>

          <span
            class="block shrink-0 text-[0.75rem] xl:text-[0.85rem] 2xl:text-[0.95rem] 3xl:text-[1rem] font-semibold text-dimot-1 mb-1"
          >
            Completo
          </span>

          <span
            class="block shrink-0 text-[0.57rem] xl:text-[0.59rem] 2xl:text-[0.66rem] 3xl:text-[0.72rem] leading-snug text-gray-500"
          >
            Genera le slide di tutti i widget presenti nella dashboard nazionale.
          </span>
        </button>

        <!-- Card: Personalizza -->
        <button
          type="button"
          (click)="selected = 'custom'"
          [attr.aria-pressed]="selected === 'custom'"
          class="group relative h-full min-h-0 min-w-0 flex flex-col overflow-y-auto text-left
                 rounded-lg border border-gray-200 bg-white
                 p-3.5 xl:p-4 2xl:p-5 cursor-pointer
                 transition-colors duration-200 motion-reduce:transition-none
                 hover:border-dimot-1/40 hover:bg-dimot-1/[0.015]
                 aria-pressed:border-dimot-1 aria-pressed:hover:border-dimot-1 aria-pressed:bg-dimot-1/[0.03]
                 focus:outline-none focus-visible:ring-2 focus-visible:ring-dimot-1/20 focus-visible:ring-offset-2"
        >
          <div class="flex shrink-0 items-start justify-between gap-3 w-full mb-4">
            <div
              class="shrink-0 w-8 h-8 xl:w-9 xl:h-9 2xl:w-10 2xl:h-10 rounded-md bg-dimot-1/[0.07] flex items-center justify-center"
            >
              <svg
                aria-hidden="true"
                class="w-4 h-4 xl:w-[1.1rem] xl:h-[1.1rem] 2xl:w-5 2xl:h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#141F58"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="4" y1="7" x2="20" y2="7" />
                <line x1="4" y1="17" x2="20" y2="17" />
                <circle cx="9" cy="7" r="2.2" fill="white" />
                <circle cx="15" cy="17" r="2.2" fill="white" />
              </svg>
            </div>

            <!-- Selection indicator -->
            <span
              aria-hidden="true"
              class="mt-0.5 w-4 h-4 shrink-0 rounded-full border border-gray-400 flex items-center justify-center
                     transition-colors duration-200
                     group-aria-pressed:border-dimot-1 group-aria-pressed:bg-dimot-1"
            >
              <span
                class="w-1.5 h-1.5 rounded-full bg-white opacity-0 group-aria-pressed:opacity-100"
              ></span>
            </span>
          </div>

          <span
            class="block shrink-0 text-[0.75rem] xl:text-[0.85rem] 2xl:text-[0.95rem] 3xl:text-[1rem] font-semibold text-dimot-1 mb-1"
          >
            Personalizza
          </span>

          <span
            class="block shrink-0 text-[0.57rem] xl:text-[0.59rem] 2xl:text-[0.66rem] 3xl:text-[0.72rem] leading-snug text-gray-500"
          >
            Scegli le slide da includere nel report al prossimo passaggio.
          </span>
        </button>
      </div>
    </div>

    
<!-- Footer -->
<div class="flex shrink-0 justify-center gap-3 pb-4 mt-1">

  <button
    type="button"
    (click)="closeModal()"
    class="border border-dimot-1 bg-white text-dimot-1
           hover:bg-dimot-1 hover:text-white
           w-32 h-8 rounded-md flex flex-row justify-center
           gap-2 items-center cursor-pointer
           relative transition-colors duration-300"
  >
    <span class="text-[0.7rem]">Annulla</span>
  </button>

  <button
    type="button"
    (click)="continue()"
    [disabled]="!selected"
    class="border border-dimot-1 bg-dimot-1 text-white
           hover:bg-white hover:text-dimot-1
           w-32 h-8 rounded-md flex flex-row justify-center
           gap-2 items-center group cursor-pointer relative
           transition-colors duration-300
           disabled:opacity-40 disabled:cursor-not-allowed
           disabled:hover:bg-dimot-1
           disabled:hover:text-white"
  >
    <span class="text-[0.7rem]">Continua</span>
  </button>
</div>
    </ng-container>

<!-- PHASE 1 -->
<ng-container *ngIf="phase === 1">
  <!-- Body -->
  <div class="flex-1 min-h-0 flex flex-col overflow-y-auto scrollbar px-6 py-5 bg-[#FBFCFD]">
    <!-- GRID -->
    <div *ngIf="widgets.length > 0" class="widgets-grid">
      <button
        *ngFor="let widget of widgets; let i = index; trackBy: trackById"
        type="button"
        class="widget-card group relative flex flex-col text-left rounded-xl bg-white border-2 overflow-hidden cursor-pointer transition-all duration-200"
        [class.widget-card--wide]="isWide(widget)"
        [style.animation-delay.ms]="i * 25"
        [attr.aria-pressed]="isWidgetSelected(widget)"
        [ngClass]="getCardClasses(widget)"
        (click)="toggleWidget(widget)"
      >
        <div
          class="relative flex-none h-[150px] 2xl:h-[170px] bg-tableHead border-b border-gray-100 overflow-hidden"
        >
          <div
            class="widget-preview absolute inset-3 transition-transform duration-300 group-hover:scale-[1.03]"
            [ngClass]="widget.className"
          ></div>

          <span
            class="absolute top-2 right-2 w-5 h-5 rounded-full border-2 grid place-items-center transition-all"
            [ngClass]="getCheckClasses(widget)"
          >
            <svg
              *ngIf="isWidgetSelected(widget)"
              class="w-3 h-3 text-white"
              viewBox="0 0 24 24" fill="none" aria-hidden="true"
            >
              <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>

        <div class="flex-1 flex flex-col gap-1 px-3 py-2.5">
          <h3
            class="font-semibold text-dimot-1 text-[0.62rem] 2xl:text-[0.72rem] leading-snug line-clamp-2"
          >
            {{ getWidgetTitle(widget) }}
          </h3>
          <p
            class="text-gray-500 text-[0.55rem] 2xl:text-[0.63rem] leading-relaxed line-clamp-2"
          >
            {{ getTooltipText(widget.id) }}
          </p>
        </div>

        <!-- hover panel -->
        <div
          [ngClass]="getHoverPanelHeight(widget)"
          class="absolute inset-x-0 bottom-0 z-10 flex flex-col gap-1 px-3 py-2.5 bg-white border-t border-gray-100
                 shadow-[0_-6px_16px_-8px_rgba(20,30,88,0.25)] pointer-events-none
                 opacity-0 translate-y-2 transition-all duration-200
                 group-hover:opacity-100 group-hover:translate-y-0
                 group-focus-visible:opacity-100 group-focus-visible:translate-y-0"
          aria-hidden="true"
        >
          <h3 class="font-semibold text-dimot-1 text-[0.62rem] 2xl:text-[0.72rem] leading-snug">
            {{ getWidgetTitle(widget) }}
          </h3>
          <p class="text-gray-500 text-[0.55rem] 2xl:text-[0.63rem] leading-relaxed">
            {{ getTooltipText(widget.id) }}
          </p>
        </div>
      </button>
    </div>

    <!-- no widgets in the national dashboard -->
    <div
      *ngIf="widgets.length === 0"
      class="flex-1 flex flex-col items-center justify-center text-center gap-2 py-14"
    >
      <h4 class="text-dimot-1 font-semibold text-[0.75rem] 2xl:text-[0.85rem]">Nessun widget disponibile</h4>
      <p class="text-gray-500 text-[0.6rem] 2xl:text-[0.7rem] max-w-[320px]">
        Non ci sono widget nella dashboard nazionale da includere nel report.
      </p>
    </div>
  </div>

  <!-- Footer -->
  <div
    class="flex-none flex flex-col sm:flex-row items-center justify-between gap-3 px-6 py-4 border-t border-gray-100 bg-white"
  >
    <div class="flex items-center gap-3 text-[0.62rem] 2xl:text-[0.75rem] text-dimot-1">
      <span aria-live="polite" aria-atomic="true">
        Hai selezionato <span class="font-bold">{{ selectedWidgetIds.size }}</span> widget
      </span>
      <button
        *ngIf="widgets.length > 0"
        type="button"
        (click)="toggleSelectAll()"
        class="font-medium text-[#0A778A] hover:underline cursor-pointer"
      >
        {{ allWidgetsSelected ? 'Deseleziona Tutti' : 'Seleziona Tutti' }}
      </button>
    </div>

    <div class="flex items-center gap-2">
      <button
        type="button"
        (click)="back()"
        class="h-8 2xl:h-9 px-4 rounded-lg border border-gray-200 bg-white text-gray-600
               text-[0.62rem] 2xl:text-[0.72rem] font-medium cursor-pointer hover:bg-gray-50 transition"
      >
        Indietro
      </button>
      <button
        type="button"
        (click)="confirmWidgets()"
        [disabled]="selectedWidgetIds.size === 0"
        class="h-8 2xl:h-9 px-4 rounded-lg bg-dimot-1 text-white inline-flex items-center gap-2
               text-[0.62rem] 2xl:text-[0.72rem] font-medium cursor-pointer transition
               hover:bg-dimot-1/90 active:scale-[0.98]
               disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100"
      >
        Continua
      </button>
    </div>
  </div>
</ng-container>

  </div>
</div>
